(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movelio-email-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('movelio-email-popup')) {
  customElements.define('movelio-email-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.bound) return;
      this.bound = true;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      const key = 'movelio-email-popup-until-v1';
      const editor = this.dataset.editor === 'true';
      const remember = (days) => {if (!editor) {try {localStorage.setItem(key,String(Date.now()+days*86400000));} catch(e) {}}};
      this.querySelector('.mv-email__close').addEventListener('click',()=>{this.dialog.close();remember(Number(this.dataset.days));},opts);
      this.dialog.addEventListener('keydown',e=>{if(e.key==='Escape'){this.dialog.close();remember(Number(this.dataset.days));}},opts);
      const form = this.querySelector('form');
      form.addEventListener('submit',()=>{try{sessionStorage.setItem('movelio-popup-submitted','1');}catch(e){}},opts);
      let submitted = false;
      try {submitted = sessionStorage.getItem('movelio-popup-submitted') === '1';} catch(e) {}
      const result = this.querySelector('[data-result]');
      if(result && submitted){this.dialog.show();if(result.dataset.result==='success'){remember(365);try{sessionStorage.removeItem('movelio-popup-submitted');}catch(e){}}return;}
      if(editor){this.dialog.show();return;}
      try{if(Number(localStorage.getItem(key))>Date.now())return;}catch(e){}
      let ready = false;
      let shown = false;
      const maybeShow = () => {
        if(!ready || shown || document.hidden) return;
        const distance = document.documentElement.scrollHeight-innerHeight;
        if(distance<=0 || scrollY/distance*100<Number(this.dataset.scroll))return;
        if(document.activeElement?.matches('input,textarea,select') || document.querySelector('dialog[open],cart-drawer.active,[role="dialog"][aria-modal="true"]'))return;
        shown=true;remember(Number(this.dataset.days));this.dialog.show();
      };
      addEventListener('scroll',maybeShow,{passive:true,...opts});
      document.addEventListener('visibilitychange',maybeShow,opts);
      this.timer=setTimeout(()=>{ready=true;maybeShow();},Number(this.dataset.delay)*1000);
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movelio-home-how"] && !Shopify.designMode) return;
  try {
    
  function startMovelioStepVideos(root) {
    const videos = root.querySelectorAll('.movelio-home-step__video:not([data-playback-ready])');
    function play(video) {
      video.autoplay = true;
      const playback = video.play();
      if (playback) playback.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        play(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    videos.forEach(function (video) {
      video.setAttribute('data-playback-ready', 'true');
      observer.observe(video);
    });
  }
  startMovelioStepVideos(document);
  document.addEventListener('shopify:section:load', function (event) {
    startMovelioStepVideos(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movelio-partner-soknad"] && !Shopify.designMode) return;
  try {
    
  function initMovelioPartnerForms(root) {
    root.querySelectorAll('.msp-apply__form').forEach(function (form) {
      if (form.dataset.partnerFormReady === 'true') return;
      form.dataset.partnerFormReady = 'true';

      var companyChoices = form.querySelectorAll('[data-company-choice]');
      var companyFields = form.querySelector('[data-company-fields]');
      var requiredCompanyFields = companyFields ? companyFields.querySelectorAll('[data-company-required]') : [];

      function updateCompanyFields() {
        var selectedChoice = form.querySelector('[data-company-choice]:checked');
        var showCompanyFields = selectedChoice && selectedChoice.value === 'Ja';

        if (companyFields) companyFields.hidden = !showCompanyFields;
        requiredCompanyFields.forEach(function (field) {
          field.required = Boolean(showCompanyFields);
          if (!showCompanyFields) field.value = '';
        });
      }

      companyChoices.forEach(function (choice) {
        choice.addEventListener('change', updateCompanyFields);
      });
      updateCompanyFields();
    });
  }

  initMovelioPartnerForms(document);
  document.addEventListener('shopify:section:load', function (event) {
    initMovelioPartnerForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movelio-retail-application"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-retail-category-group]').forEach((group) => {
    const form = group.closest('form');
    const checkboxes = Array.from(group.querySelectorAll('[data-retail-category-checkbox]'));
    const error = group.querySelector('[data-retail-category-error]');

    if (!form || checkboxes.length === 0 || group.dataset.validationReady === 'true') return;
    group.dataset.validationReady = 'true';

    const clearError = () => {
      checkboxes[0].setCustomValidity('');
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
    };

    checkboxes.forEach((checkbox) => checkbox.addEventListener('change', clearError));

    form.addEventListener('submit', (event) => {
      if (checkboxes.some((checkbox) => checkbox.checked)) {
        clearError();
        return;
      }

      const message = group.dataset.errorMessage || 'Velg minst én bransje.';
      checkboxes[0].setCustomValidity(message);
      if (error) {
        error.hidden = false;
        error.textContent = message;
      }
      event.preventDefault();
      checkboxes[0].reportValidity();
      checkboxes[0].focus();
    });
  });

  document.querySelectorAll('[data-retail-website]').forEach((input) => {
    const form = input.closest('form');

    if (!form || input.dataset.normalizationReady === 'true') return;
    input.dataset.normalizationReady = 'true';

    const normalizeWebsite = () => {
      const value = input.value.trim();
      if (!value) return;

      input.value = /^[a-z][a-z\d+.-]*:\/\//i.test(value)
        ? value
        : `https://${value.replace(/^\/\//, '')}`;
    };

    input.addEventListener('blur', normalizeWebsite);
    form.addEventListener('submit', normalizeWebsite);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movelio-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  const movelioCountdowns = document.querySelectorAll('[data-movelio-countdown]');

  movelioCountdowns.forEach((countdown) => {
    if (countdown.dataset.initialized === 'true') return;
    countdown.dataset.initialized = 'true';

    const deadline = new Date(countdown.dataset.deadline).getTime();
    const days = countdown.querySelector('[data-countdown-days]');
    const hours = countdown.querySelector('[data-countdown-hours]');
    const minutes = countdown.querySelector('[data-countdown-minutes]');
    const seconds = countdown.querySelector('[data-countdown-seconds]');

    const render = () => {
      const remaining = deadline - Date.now();

      if (!Number.isFinite(deadline) || remaining <= 0) {
        countdown.hidden = true;
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
      hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
      minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
      seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      countdown.hidden = false;
      return true;
    };

    if (render()) {
      const interval = window.setInterval(() => {
        if (!render()) window.clearInterval(interval);
      }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-explore"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => root.querySelectorAll('[data-explore]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const tabs = [...section.querySelectorAll('[role=tab]')];
    const comparison = section.closest('.shopify-section').previousElementSibling;
    if (comparison) new ResizeObserver(entries => section.style.setProperty('--mv-compare-height', entries[0].contentRect.height + 'px')).observe(comparison);
    const select = tab => {
      section.querySelectorAll('.mv-explore-card:popover-open').forEach(card => card.hidePopover());
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        panel.hidden = !active;
        if (active) panel.querySelector('.mv-explore-controls').prepend(section.querySelector('[role=tablist]'));
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); select(tabs[next]); tabs[next].focus();
      });
    });
    section.querySelectorAll('.mv-explore-panel').forEach(panel => {
      const visual = panel.querySelector('.mv-explore-visual');
      const pins = [...panel.querySelectorAll('.mv-explore-trigger')];
      let frame;
      const place = (card, pin) => {
        const area = visual.getBoundingClientRect();
        const anchor = pin.getBoundingClientRect();
        const box = card.getBoundingClientRect();
        const viewport = window.visualViewport;
        const edgeX = viewport?.offsetLeft || 0;
        const edgeY = viewport?.offsetTop || 0;
        const width = viewport?.width || window.innerWidth;
        const height = viewport?.height || window.innerHeight;
        let x = anchor.left + anchor.width / 2 - box.width / 2;
        x = Math.max(edgeX + 16, Math.min(x, edgeX + width - box.width - 16));
        let y = anchor.top - box.height - 12;
        if (y < edgeY + 16) y = anchor.bottom + 12;
        y = Math.max(edgeY + 16, Math.min(y, edgeY + height - box.height - 16));
        card.style.left = `${Math.round(x)}px`;
        card.style.top = `${Math.round(y)}px`;
      };
      pins.forEach(pin => {
        const card = document.getElementById(pin.getAttribute('aria-controls'));
        card.addEventListener('toggle', () => {
          const open = card.matches(':popover-open');
          pin.setAttribute('aria-expanded', String(open));
          if (open) place(card, pin);
        });
      });
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => pins.forEach(pin => {
          const card = document.getElementById(pin.getAttribute('aria-controls'));
          if (card.matches(':popover-open')) place(card, pin);
        }));
      };
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('scroll', update, { passive: true });
    });
    section.addEventListener('shopify:block:select', event => {
      const tab = tabs.find(item => item.getAttribute('aria-controls') === event.target.id);
      if (tab) select(tab);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    root.querySelectorAll('.mv-hero-has-video').forEach(hero => {
      const video = hero.querySelector('video');
      if (!video || hero.dataset.videoReady) return;
      hero.dataset.videoReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktopMedia = window.matchMedia('(min-width:1001px)');
      const autoAllowed = () => !reduced.matches && !navigator.connection?.saveData;
      const play = () => { video.play().catch(() => {}); };
      video.muted = true;
      video.loop = true;
      let visible = false;
      const sync = () => { if (visible && !document.hidden && autoAllowed()) play(); else video.pause(); };
      reduced.addEventListener('change', sync);
      desktopMedia.addEventListener('change', () => { video.load(); });
      video.addEventListener('loadeddata', sync);
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.15 });
        observer.observe(hero);
      } else { visible = true; sync(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const quantityButton = event.target.closest('[data-mv-quantity]');
  if (!quantityButton) return;
  const input = quantityButton.parentElement.querySelector('input');
  const value = Math.max(1, Math.min(10, (Number(input.value) || 1) + Number(quantityButton.dataset.mvQuantity)));
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
document.addEventListener('click', (event) => {
  const arrow = event.target.closest('[data-mv-gallery-step]');
  if (!arrow) return;
  const buttons = [...arrow.closest('[data-mv-gallery]').querySelectorAll('[data-mv-gallery-image]')];
  if (buttons.length < 2) return;
  const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
  buttons[(current + Number(arrow.dataset.mvGalleryStep) + buttons.length) % buttons.length].click();
});
document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('.mv-share-trigger');
  const copy = event.target.closest('[data-mv-share-copy]');
  const outside = !event.target.closest('[data-mv-share]');
  if (outside) document.querySelectorAll('[data-mv-share]').forEach((el) => { el.querySelector('.mv-share-menu').hidden = true; el.querySelector('.mv-share-trigger').setAttribute('aria-expanded', 'false'); });
  if (trigger) {
    const root = trigger.closest('[data-mv-share]');
    if (navigator.share) {
      try { await navigator.share({title: root.dataset.title, url: root.dataset.url}); return; } catch (err) { if (err.name === 'AbortError') return; }
    }
    const menu = root.querySelector('.mv-share-menu');
    menu.hidden = !menu.hidden;
    trigger.setAttribute('aria-expanded', String(!menu.hidden));
  }
  if (copy) {
    const root = copy.closest('[data-mv-share]');
    try { await navigator.clipboard.writeText(root.dataset.url); root.querySelector('[data-mv-share-status]').textContent = root.querySelector('[data-mv-share-status]').dataset.message; }
    catch (err) { window.prompt('URL', root.dataset.url); }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = root => {
    root.querySelectorAll('[data-mv-review-photo-label]').forEach(widget => {
      if (widget.dataset.mvPhotoReady) return;
      widget.dataset.mvPhotoReady = 'true';
      const label = widget.dataset.mvReviewPhotoLabel;
      const localize = () => {
        widget.querySelectorAll('img[alt], a[aria-label]').forEach(element => {
          const attribute = element.tagName === 'IMG' ? 'alt' : 'aria-label';
          const current = element.getAttribute(attribute);
          const updated = current.replace(/ review photo(?=\s*\d*$)/i, ' – ' + label);
          if (updated !== current) element.setAttribute(attribute, updated);
        });
      };
      localize();
      new MutationObserver(localize).observe(widget, {childList:true, subtree:true, attributes:true, attributeFilter:['alt','aria-label']});
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
